// Abgleich eines frei eingetragenen Namens (z. B. „Gutachten lt. Kunde")
// mit den Beteiligten des Falls – Kundenfeedback 14.10.2026 (II).

export interface ParticipantLike {
  name?: string
  description?: string
  companyName?: string
  email?: string
  roles?: string[]
  removedAt?: string | null
}

const LEGAL_FORMS = /\b(gmbh|mbh|ag|kg|ohg|gbr|ug|e\.?\s?k\.?|co\.?|&|und|partner|haftungsbeschränkt)\b/g

/** Vergleichsform: klein, ohne Rechtsform, Satzzeichen und doppelte Leerzeichen. */
export function normalizeCompanyName (raw: string): string {
  return (raw || '')
    .toLowerCase()
    .replace(/<[^>]*>/g, ' ')
    .replace(LEGAL_FORMS, ' ')
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

/** true, wenn ein aktiver Beteiligter mit der Rolle den Namen trägt. */
export function isNameAmongParticipants (name: string, participants: ParticipantLike[], role: string): boolean {
  const wanted = normalizeCompanyName(name)
  if (!wanted) return true
  return participants.some(p => {
    if (p.removedAt) return false
    if (role && !(p.roles || []).includes(role)) return false
    return [p.name, p.description, p.companyName].some(candidate => {
      const have = normalizeCompanyName(candidate || '')
      return !!have && (have.includes(wanted) || wanted.includes(have))
    })
  })
}
